import { http, HttpResponse } from 'msw';

import { apiRoutes as sharedApiRoutes } from '@features/campaigns/shared/consts/apiRoutes.ts';
import { apiRoutes } from '@features/campaigns/thematicPackage/consts/apiRoutes.ts';
import {
  mockedCreatedThematicPackageCampaign,
  mockedThematicPackages,
} from '@shared/mocks/requests/thematicPackages/thematicPackages.fixtures.ts';

export const thematicPackagesRequests = [
  http.get(`*${sharedApiRoutes.getThematicPackages()}`, () => {
    return HttpResponse.json(mockedThematicPackages);
  }),
  http.post(`*${apiRoutes.createThematicPackageCampaign(':campaignId')}`, () => {
    return HttpResponse.json(mockedCreatedThematicPackageCampaign);
  }),
];
